import React from "react"
import { Mutation } from "react-apollo"
import gql from "graphql-tag"

class LoginModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      email: "",
      password: "",
      error: null,
    }
  }

  handleInputChange = (e) => {
    const { name, value } = e.target
    this.setState({ [name]: value, error: null })
  }

  onSubmit = async (e) => {
    e.preventDefault()
    try {
      if (!this.state.email || !this.state.password) {
        this.setState({
          error: "Email and Password are required.",
        })
      }

      const { data } = await this.props.login({
        variables: this.state,
      })

      if (data.login.adminResponse.payload === "success") {
        this.props.close()
        return
      } else {
        this.setState({
          error: data.login.adminResponse.message,
        })
      }
    } catch (err) {
      console.log(err)
      this.setState({
        error: "Unable to log in to admin portal.",
      })
    }
  }

  render = () => {
    return (
      <div
        className="modal"
        role="dialog"
        style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="login-modal-title">
                Login
              </h5>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={this.props.close}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={this.onSubmit}>
                <div className="form-group">
                  <label className="col-form-label">Email</label>
                  <input
                    className="form-control"
                    name="email"
                    type="email"
                    id="login-modal-email"
                    aria-describedby="emailHelp"
                    placeholder="Email"
                    onChange={this.handleInputChange}
                    value={this.state.email}
                  />
                </div>
                <div className="form-group">
                  <label className="col-form-label">Password</label>
                  <input
                    className="form-control"
                    name="password"
                    type="password"
                    id="login-modal-password"
                    placeholder="Password"
                    onChange={this.handleInputChange}
                    value={this.state.password}
                  />
                </div>
                {this.state.error && (
                  <div className="alert alert-danger" role="alert">
                    {this.state.error}
                  </div>
                )}
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const LOGIN_MODAL_MUTATION = gql`
  mutation LOGIN_MODAL_MUTATION($email: String!, $password: String!) {
    login(email: $email, password: $password, deviceType: "desktop") {
      id
      adminResponse {
        payload
        message
      }
    }
  }
`

const LoginModalWithData = (props) => (
  <Mutation mutation={LOGIN_MODAL_MUTATION} update={() => {}}>
    {(login) => <LoginModal login={login} {...props} />}
  </Mutation>
)

export default LoginModalWithData
